import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsWebApps(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá vývoj webové aplikace na míru?",
			answer:
				"První produkční verze zabere typicky kolem 3 měsíců, realizace celé aplikace trvá 6-24 měsíců. Doba vývoje záleží na rozsahu aplikace a implementovaných funkcích.",
		},
		{
			question: "Kolik webové aplikace stojí?",
			answer:
				"Ceny se pohybují od 200 do 500 tisíc Kč v případě velmi jednoduchých aplikací, většinou vývoj stojí průměrně 1-2 miliony Kč. Vždy vám ale pošleme nacenění, protože každá webová aplikace je unikátní.",
		},
		{
			question: "Jsou náklady na údržbu a aktualizace aplikace zahrnuty v ceně?",
			answer: "Ano, technický servis je v ceně po dobu 1 roku od spuštění aplikace do produkce.",
		},
		{
			question: "Lze webovou aplikaci integrovat s naším stávajícím systémem?",
			answer:
				"Pokud se nejedná o striktně uzavřené řešení, zvládneme aplikaci propojit téměř s jakýmkoli systémem. Většinou je však potřeba, aby měl systém API.",
		},
		{
			question: "Jakou podporu budu mít k dispozici během vývoje?",
			answer:
				"Během vývoje vám přidělíme projektového manažera, který se o vás bude pečlivě starat 7 dní v týdnů, a vývojový tým. Podpora je standardně aktivní v době od 9 do 15 hodin, ale často se zákazníky komunikujeme i mimo tuto dobu.",
		},
	];
}
